import type { z } from 'zod';

import type { NodeDefinition, PortCounts } from './types';

/** Declares a node type; the config schema types `cardinality`. */
export function defineNode<C extends z.ZodType>(
  definition: NodeDefinition<C>,
): NodeDefinition<C> {
  return definition;
}

/** Every item arriving, across all input ports. */
export function total(inputs: PortCounts): number {
  return Object.values(inputs).reduce((sum, count) => sum + count, 0);
}

/** One item out per item in, on the `out` port. */
export const passThrough = (_config: unknown, inputs: PortCounts): PortCounts => ({
  out: total(inputs),
});

/** A starter's fixed count on its `out` port. */
export const emits = (count: number): PortCounts => ({ out: count });

/** The trigger handle every data starter has, for Schedule to connect into. */
export const TRIGGER_INPUT = {
  id: 'trigger',
  label: 'Trigger',
  accepts: 'trigger',
  optional: true,
} as const;
